import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import UserProfile from "../../components/LandLord/UserProfile";

export default function UserProfileTest() {
  const { user } = useSelector((state) => state.auth);
  // console.log("User Profile Test Page", user);

  // Use actual user data from Redux store instead of hardcoded values
  const initialData = {
    fullName: user ? `${user.firstName || ''} ${user.lastName || ''}`.trim() : "",
    email: user?.email || "",
    phoneNumber: user?.phoneNumber || "",
    mobileMoneyProvider: user?.payout?.mobileMoney?.mobileMoneyProvider || "",
    mobileMoneyNumber: user?.payout?.mobileMoney?.mobileNumber || "",
    accHolderFullName: user?.payout?.mobileMoney?.accHolderFullName || user?.payout?.bankDetails?.accHolderFullName || "",
    profilePicture: user?.profilePicture || "",
    bankName: user?.payout?.bankDetails?.bankName || "",
    accountNumber: user?.payout?.bankDetails?.accNumber || "",
    branchName: user?.payout?.bankDetails?.branchName || "",
    paymentMethod: user?.payout?.method || "",
  };

  const handleSave = (data) => {
    // Here you can handle the save action, e.g., send data to an API
  };

  const handleCancel = () => {
    // Here you can handle the cancel action, e.g., navigate back or reset form
  };

  // console.log("initialData", initialData);

  return (
    <div className="overflow-visible">
      {/*<PageHeader title="User Profile" user={{ name: "Jin Yang asdsagdasg" }} />*/}
      <div className="p-4 sm:p-6 md:p-[30px]">
        <UserProfile initialData={initialData} onSave={handleSave} onCancel={handleCancel} />
      </div>
    </div>
  );
}
